// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5dfaee2","732":"c7f39b45","977":"93de5ba3"}[chunkId] + ".chunk.js";
};